import CountUp from "countup.js";

// Wait for jQuery to be available before using it
(function waitForJQuery() {
    const $ = window.jQuery || window.$;
    if ($ && typeof $.fn !== 'undefined') {
        $(document).on('inview', function (e) {
            const el = e.target;
            $(el).find('.counter').each(function (i, el) {
                const counter = new CountUp(el, 0, $(el).data('counter'));
                counter.start();
            });
        });
    } else {
        // jQuery not loaded yet, retry after a short delay
        setTimeout(waitForJQuery, 50);
    }
})();


// WEBPACK FOOTER //
// ./src/portal/home-counters.js